import "./ThemeProvider_module.css";
const ThemeProvider_module = {
    defaultTheme: "defaultTheme__28101ef6fdfe9559"
};
export { ThemeProvider_module as default };
